import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "distr",
  "use": "distr-usage",
  "viewBox": "0 0 50 50",
  "content": "<symbol viewBox=\"0 0 50 50\" id=\"distr\"><defs><style>#distr .cls-1{fill:#3badf6;}#distr .cls-2{fill:#fff;}</style></defs><title>资源 46</title><g id=\"distr_图层_2\" data-name=\"图层 2\"><g id=\"distr_图层_1-2\" data-name=\"图层 1\"><rect class=\"cls-1\" width=\"50\" height=\"50\" /><path class=\"cls-2\" d=\"M38.65,27.62c-5-5.14-4.52-7.1-3.78-9.16s-1.06-11.09-7.73-7.57-4.68,8.22-9.44,8S7.09,21.24,10.58,30.66c1.36,3.68,4,7.25,8,7.76s10.6-.8,14.62,1.2,10.52-6.86,5.49-12Zm-6.57,9.64c-3.39-1.58-8.93-.65-12.33-1a8.73,8.73,0,0,1-7.14-5.72c-2.86-7.6,2.67-9.75,6.71-9.63s2.32-4.58,8-7.5,6.06,4.63,5.41,6.3c-.75,1.93-.69,3.76,3.72,8.06,4.22,4.12-1,11.09-4.39,9.51ZM15.16,25.87c-1.83,1.58-.26,5.31,2.1,6.08a6.7,6.7,0,0,0,6.53-1.68c1.83-1.6,1.59-7.11-1.46-5.68S18.89,22.66,15.16,25.87ZM28.45,15.28c-2.19.56-4.25,4.24-3.37,5.87s2.79,4.53,2.16,6.63-.16,4.64,1.93,5.39,6.55.5,6.6-1.7-5.27-4.54-5.42-8.13,1.64-9-1.91-8.06Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/distr.svg
// module id = U5fc
// module chunks = 264